// 第1张
const imgAllA = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1723608017028/%E4%BE%BF%E6%90%BA.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1723608062100/%E4%BE%BF%E6%90%BA.jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724663475962/t2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724663476340/n2.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725267244431/light.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725156601157/euH2.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725163102424/ukPC2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725163102946/ukH2.jpg',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751010201879/2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1751010201672/2_m.jpg',
    },
};
const imgLocale: any = {
    jp: imgAllA.JP,
    us: imgAllA.NA,
    ca: imgAllA.NA,
    br: imgAllA.NA,
    mx: imgAllA.NA,
    uk: imgAllA.UK,
    eu: imgAllA.EU,
    de: imgAllA.EU,
    fr: imgAllA.EU,
    it: imgAllA.EU,
    es: imgAllA.EU,
    nl: imgAllA.EU,
    ph: imgAllA.PH,
};
export default imgLocale;
